import React from "react";
import * as dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/fr";
import { AlertsProvider, PageContextProvider, NotificationsProvider } from "./src/context";
import { RCLProvider } from "./src/components/RCL";
import { SecurityProvider } from "./src/templates/user-account/context/SecurityProvider";
import "./src/styles/index.scss";

// Utility to set manifest link (removes any previous manifest links)
function setManifestHref(href) {
	if (!href) return;
	try {
		// remove existing manifest link tags
		const existing = document.querySelectorAll('link[rel="manifest"]');
		existing.forEach(n => n.parentNode && n.parentNode.removeChild(n));

		// create new manifest link
		const l = document.createElement("link");
		l.rel = "manifest";
		l.href = href;
		document.getElementsByTagName("head")[0].appendChild(l);
	} catch (e) {
		// noop
	}
}

// Wraps every page in a component
export const wrapPageElement = ({ element, props }) => {
	const lang = props?.pageContext?.locale?.substring(0, 2)?.toLowerCase() || "en";
	dayjs.locale(lang === "fr" ? "fr" : "en");

	return (
		<SecurityProvider lang={props?.pageContext?.locale}>
			<PageContextProvider data={{ ...props?.pageContext, lang }}>
				<AlertsProvider lang={props?.pageContext?.locale} timestamp={props?.pageContext?.timestamp}>
					<RCLProvider lang={props?.pageContext?.locale}>
						<NotificationsProvider locale={props?.pageContext?.locale}>
							{element}
						</NotificationsProvider>
					</RCLProvider>
				</AlertsProvider>
			</PageContextProvider>
		</SecurityProvider>
	);
};

function getLanguage(location) {
	const path = (location && location.pathname) || "";
	const parts = path.split("/").filter(Boolean);
	const prefix = parts[0] || "";

	let manifest = "/site.webmanifest";
	if (/^fr($|-)/i.test(prefix)) manifest = "/site.fr.webmanifest";
	else if (/^en($|-)/i.test(prefix)) manifest = "/site.en.webmanifest";
	return manifest;
}

// Called every time the route changes (including first load)
export const onRouteUpdate = ({ location, prevLocation }) => {
	if (window?.analytics && prevLocation && prevLocation.pathname !== location.pathname) {
		setTimeout(() => {
			// Trigger Segment page tracking
			window.analytics.page({ brand_code: process.env.GATSBY_SEGMENT_BRAND_CODE });
		}, 10);
	}

	try {
		const currentManifest = getLanguage(location);
		if (currentManifest !== getLanguage(prevLocation)) {
			setManifestHref(currentManifest);
		}
	} catch (e) {
		// Fail to determine pathname
	}
};
